module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-178.092c2fc8.jpg";